<template>
    <div>
        <CFTitle title="4. Persoana de contact"></CFTitle>

        <div class="mt-5">
            <div class="flex space-between items-center padding-flex custom-responsive">
                <div class="alege-asociat flex">
                    <p>Alege dintre asociați</p>
                    <v-select
                        v-model="asociatSelectat"
                        class="w-96"
                        dir="ltr"
                        :options="getAssociates"
                        label="name"
                        input-id="id_series"
                        :clearable="false"
                        :class="completed ? 'disabled-select' : '' "
                        @input="selectedAssociateChanged"
                    >
                        <span slot="no-options">
                            Nu există asociați adăugați.
                        </span>
                    </v-select>
                </div>
                <div class="yellow-button" @click="clearAssociate()">
                    Adaugă o persoană diferită
                </div>
            </div>
            <validation-observer #default="{ invalid }" ref="responsabilProiect">
                <span class="display-none">{{ invalid }}</span>
                <div class="flex justify-content-center mb-1 modify-res">
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 30%;"
                        class="w-32"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="3"
                            content-cols-lg="9"
                            label="Nume"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="form.first_name"
                                type="text"
                                :readonly="completed"
                                :state="errors.length > 0 ? false : null"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 27%;"
                        class="w-32"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Prenume"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="form.last_name"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 25.6%;"
                        class="w-32"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Funcție"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="form.position"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                </div>
                <div class="flex justify-content-center mb-1 modify-res">
                    <validation-provider
                        #default="{ errors }"
                        rules="required|numeric"
                        style="width: 30%;"
                        class="w-32"
                        name="telefon"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="3"
                            content-cols-lg="9"
                            label="Telefon"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="form.phone"
                                type="number"
                                :readonly="completed"
                                :state="errors.length > 0 ? false : null"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required"
                        style="width: 27%;"
                        class="w-32"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Fax"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="form.fax"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                    <validation-provider
                        #default="{ errors }"
                        rules="required|email"
                        style="width: 25.6%;"
                        class="w-32"
                    >
                        <b-form-group
                            id="fieldset-horizontal"
                            label-cols-lg="4"
                            content-cols-lg="8"
                            label="Email"
                            class="has-icon custom-responsive"
                        >
                            <b-form-input
                                v-model="form.email"
                                type="text"
                                :state="errors.length > 0 ? false : null"
                                :readonly="completed"
                            ></b-form-input>
                            <small class="text-danger">{{ errors[0] }}</small>
                        </b-form-group>
                    </validation-provider>
                </div>
            </validation-observer>
        </div>

        <hr class="mt-5">
        <b-form-checkbox
            v-model="completed"
            switch
            size="lg"
            class="switch-box"
            @change="sendForm()"
        >Informațiile sunt complete și corecte</b-form-checkbox>
    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import { BFormInput, BFormGroup, BFormCheckbox } from "bootstrap-vue";
    import api from '@/helpers/api'
    import axios from '@/helpers/axios'
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import vSelect from "vue-select";
    require('@/helpers/validations/validations');
    export default {
        components: {
            CFTitle,
            BFormInput, BFormGroup, BFormCheckbox,
            ValidationProvider, ValidationObserver,
            vSelect
        },
        props: {
            responsabilProiect: null,
            m3GrantApplication: null,
            data: null
        },
        data() {
            return {
                completed: false,
                asociatSelectat: null,
                form: {
                    first_name: '',
                    last_name: '',
                    position: '',
                    phone: '',
                    fax: '',
                    email: '',
                }
            }
        },
        computed: {
            getAssociates() {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.asociatiMap = this.data ? this.data.associates : []
                return this.asociatiMap ? this.asociatiMap.map(function(associate) {
                    let asociat = associate;
                    asociat.name = asociat.type == 1 ? asociat.delegate_name : asociat.name
                    delete asociat.delegate_name
                    delete asociat.company_name
                    delete asociat.business_id
                    delete asociat.type

                    return asociat;
                }) : [];
            },
            finantareProgress() {
                return this.$store.getters['finantare/progress']
            }
        },
        watch: {
            finantareProgress: {
                handler: function() {
                    if(this.finantareProgress && this.finantareProgress.includes('Persoana de contact')) {
                        this.completed = true
                    }
                },
                deep: true
            },
            m3GrantApplication: {
                handler () {
                    if(this.m3GrantApplication && this.m3GrantApplication.persoana_contact){
                        this.form = this.m3GrantApplication.persoana_contact
                    }
                },
                deep: true
            }
        },
        mounted() {
            if(this.m3GrantApplication && this.m3GrantApplication.persoana_contact) {
                this.form = this.m3GrantApplication.persoana_contact
            } else {
                if(this.responsabilProiect){
                    this.form = this.responsabilProiect
                }
            }
            if(this.finantareProgress && this.finantareProgress.includes('Persoana de contact')) {
                this.completed = true
            }
        },
        methods: {
            sendForm() {
                this.$refs.responsabilProiect.validate().then((e) => {
                    if (!e) {
                        this.completed = false
                        this.$toast.error('Te rugăm completează câmpurile marcate cu roșu.');
                    } else {
                        if(this.completed){
                            this.$store.dispatch('finantare/addToProgress', 'Persoana de contact')
                            axios.post(api.API_ENDPOINTS.m3company + JSON.parse(localStorage.getItem('currentM3Company')).id + '/grant-application',  {persoana_contact: this.form})
                                .then( () => {
                                    this.$toast.success('Informațiile au fost salvate!')
                                    this.$emit('savedData')
                                    this.$store.dispatch('finantare/addToProgress', 'Persoana de contact')
                                })
                        }
                        else{
                            this.$store.dispatch('finantare/removeFromProgress', 'Persoana de contact')
                        }
                    }
                })
            },
            selectedAssociateChanged() {
                this.form = {
                    first_name: '',
                    last_name: '',
                    position: '',
                    phone: '',
                    fax: '',
                    email: '',
                }
                this.form.first_name = this.asociatSelectat.name.split(' ')[0]
                this.form.last_name = this.asociatSelectat.name.split(' ').slice(1).join(' ')
                this.form.position = this.asociatSelectat.function ? this.asociatSelectat.function : ''
                if(this.data && this.data.delegate && Number(this.data.delegate.id_no) === Number(this.asociatSelectat.id_no)){
                    this.form.phone = this.data.delegate.phone
                    this.form.fax = this.data.delegate.fax
                    this.form.email = this.data.delegate.email
                }
            },
            clearAssociate() {
                if(!this.completed) {
                    this.form = {
                        first_name: '',
                        last_name: '',
                        position: '',
                        phone: '',
                        fax: '',
                        email: '',
                    }
                    this.asociatSelectat = null
                } else {
                    this.$toast.error('Anulează salvarea formularului înainte de a modifica.')
                }
            }
        }
    }
</script>

<style scoped>
.flex{
    display: flex;
}
.space-between{
    justify-content: space-between;
}
.items-center{
    align-items: center;
}
.flex-end{
    justify-content: flex-end;
}
.first-input{
    width: 47%;
}
.second-input{
    width: 44%;
}
.v-select{
    width: 70%;
}
.v-select >>> .vs__dropdown-menu {
    background: #e9ecef;
    max-height: 200px;
    overflow-y: hidden;
}
.v-select >>> .vs__dropdown-toggle{
    background: #e9ecef;
    margin: 0;
    border-radius: 2px;
    justify-content: space-between;
    align-items: center;
    max-height: 33px;
}
.v-select >>> .vs__actions{
    padding: 0;
}
.v-select >>> .vs__dropdown-option {
    color: #767a95;
    font-size: 13px;
    padding-left: 5px;
    font-weight: 600;
}
.v-select >>> .vs__search{
    margin: 0;
    padding: 0;
}
.v-select >>> .vs__selected{
    color: #767a95;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
}
.alege-asociat p{
    margin-right: 10px;
}
.alege-asociat{
    display: flex;
    align-items: center;
    width: 45%;
}
.yellow-button{
    border: 1px solid #ece7da;
    background: #fff4db;
    color: #767a95;
    font-size: 12px;
    font-weight: 500;
    width: 26.2%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    padding: 7px;
}
.padding-flex{
    width: 82.5%;
    margin: 0 auto 50px auto;
}
.disabled-select{
    pointer-events: none;
}
.disabled-select >>> .vs__dropdown-toggle{
    background: #d1f5ea!important;
    color:#b2b6be!important;
}
</style>
